<template>
    <div class="p-2 p-md-0">

        <!-- Loading -->
        <div v-if="loading" class="text-center py-5">
            <div class="spinner-border text-primary"></div>
            <p class="mt-3">{{ $t("sentence.loadingStats") }}</p>
        </div>

        <!-- Stats -->
        <div v-else class="row">

            <!-- USERS -->
            <div class="col-6 col-md-6 col-xl-3 mb-4 d-flex">
                <div class="stat-card h-100 w-100">
                    <i class="mdi mdi-account-group icon text-primary"></i>
                    <h2 class="value">{{ animated.totalUsers }}</h2>
                    <p class="label">{{ $t("sentence.onlineSignups") }}</p>
                </div>
            </div>

            <!-- PRODUCTS -->
            <div class="col-6 col-md-6 col-xl-3 mb-4 d-flex">
                <div class="stat-card h-100 w-100">
                    <i class="mdi mdi-tag-multiple icon text-success"></i>
                    <h2 class="value">{{ animated.nbProductInSales }}</h2>
                    <p class="label">{{ $t("sentence.nbProductInSales") }}</p>
                </div>
            </div>

            <!-- ORDERS -->
            <div class="col-6 col-md-6 col-xl-3 mb-4 d-flex">
                <div class="stat-card h-100 w-100">
                    <i class="mdi mdi-cart icon text-info"></i>
                    <h2 class="value">{{ animated.monthlyOrders }}</h2>
                    <p class="label">{{ $t("sentence.nbOfOrders") }}</p>
                </div>
            </div>

            <!-- REVENUE -->
            <div class="col-6 col-md-6 col-xl-3 mb-4 d-flex">
                <div class="stat-card h-100 w-100">
                    <i class="mdi mdi-cash-multiple icon text-danger"></i>
                    <h2 class="value">
                        {{
                            animated.revenueThisYear |
                            currency(" DA", 0, { symbolOnLeft: false })
                        }}
                    </h2>
                    <p class="label">{{ $t("sentence.yearRevenue") }}</p>
                </div>
            </div>

        </div>

        <!-- Error -->
        <div v-if="error" class="alert alert-danger mt-3">
            {{ error }}
        </div>

    </div>
</template>


<script>
export default {
    name: "AdminStats",

    data() {
        return {
            loading: true,
            error: null,

            totalUsers: 0,
            nbProductInSales: 0,
            monthlyOrders: 0,
            revenueThisYear: 0,

            animated: {
                totalUsers: 0,
                nbProductInSales: 0,
                monthlyOrders: 0,
                revenueThisYear: 0
            },
        };
    },

    mounted() {
        this.getStatistics();
    },

    methods: {
        async getStatistics() {
            try {
                const { data }=await this.$axios.get("admin/statistics");

                Object.assign(this, data);

                this.animateNumbers();

            } catch (err) {
                this.error=this.$t("sentence.errorFetchingStats");
                console.error(err);
            } finally {
                this.loading=false;
            }
        },

        animateNumbers() {
            Object.keys(this.animated).forEach((key) => {
                const target=this[key];
                let current=0;
                const step=Math.ceil(target/40);

                const timer=setInterval(() => {
                    current+=step;
                    if (current>=target) {
                        current=target;
                        clearInterval(timer);
                    }
                    this.animated[key]=current;
                }, 20);
            });
        }
    }
};
</script>

<style scoped>
.stat-card {
    background: white;
    border-radius: 14px;
    padding: 16px;
    text-align: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.06);
    display: flex;
    flex-direction: column;
    justify-content: center;
}

.icon {
    font-size: 2rem;
    margin-bottom: 8px;
}

.value {
    font-size: 1.6rem;
    font-weight: 700;
    margin: 4px 0;
}

.label {
    font-size: 0.85rem;
    color: var(--color-secondary);
}

@media (max-width: 575px) {
    .value {
        font-size: 1.3rem;
    }

    .icon {
        font-size: 1.7rem;
    }
}
</style>
